export default function toFixed(value, precision = 2) {
    return Number(value.toFixed(precision));
}
